var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-12" },
    [
      _vm.loading
        ? _c("activity-loader")
        : [
            _vm.noActivities
              ? _c("empty-message")
              : _c(
                  "div",
                  [
                    _c(
                      "transition",
                      {
                        attrs: {
                          "enter-active-class": "animated slideInDown faster",
                          "leave-active-class": "animated slideOutUp faster",
                        },
                      },
                      [
                        _vm.hasCompletedFollowups
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "sticky-top clickable w-100 text-center py-1 bg-white border-bottom font-sm",
                                on: { click: _vm.clearCompleteActivities },
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.$t(
                                        "notifications.messages.completeSelected"
                                      )
                                    ) +
                                    "\n        "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "list-group list-group-flush" },
                      [
                        _c(
                          "transition-group",
                          {
                            attrs: {
                              "enter-active-class":
                                "animated slideInLeft faster",
                              "leave-active-class":
                                "animated slideOutLeft faster",
                            },
                          },
                          _vm._l(_vm.sortedFollowUps, function (activity) {
                            return _c(
                              "upcoming-activity",
                              _vm._b(
                                {
                                  key: "" + activity.id,
                                  on: {
                                    "activity-change": _vm.handleActivityChange,
                                  },
                                },
                                "upcoming-activity",
                                Object.assign({}, activity),
                                false
                              )
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }